import dayjs from "dayjs";
// import timezone from "dayjs/plugin/timezone"; // Import timezone plugin
// import utc from "dayjs/plugin/utc"; // Import UTC plugin

// dayjs.extend(utc); // Use UTC plugin
// dayjs.extend(timezone); // Use timezone plugin

export function convertToISO8601(dateTime) {
  // Convert the dateTime to IST and then format it
  const istDate = dayjs(dateTime).toISOString();
  const istTime = `${istDate.slice(0, -5)}+05:30`;
  return istTime;
}

export function publishedDateFormat(dateTime) {
  return dayjs(dateTime).format("DD MMM YYYY");
}

export function updatedAtDateFormat(dateTime) {
  return dayjs(dateTime).format("DD MMM YYYY, hh:mm A");
}

export function publishedDateFormat2(dateTime) {
  return dayjs(dateTime).format(" • hh:mm A  • DD MMM YYYY");
}
export function publishedDateFormat3(dateTime) {
  return dayjs(dateTime).format("hh:mm A  • DD MMM YYYY");
}
export function isDateTimePassed(date) {
  const currentDatetime = dayjs();
  const otherDatetime = dayjs(date);
  if (otherDatetime.isBefore(currentDatetime)) {
    return true;
  }
  return false;
}

export function getUnixTimeDaysAgo(days = 1) {
  // Get the current date
  let now = new Date();
  // Calculate the time for 'days' days ago
  let pastDate = new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
  // Convert to UNIX timestamp and return
  return Math.floor(pastDate.getTime() / 1000);
}
export function convertDateTime(inputDateTime) {
  // Parse the input datetime string into a Date object
  const date = new Date(inputDateTime);

  // Define an array of month names to use in the output format
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract components of the date
  const month = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  let hour = date.getHours();
  const minute = date.getMinutes();

  // Convert 24-hour time to 12-hour format and determine AM/PM
  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12;
  hour = hour ? hour : 12; // the hour '0' should be '12'

  // Format minutes to ensure two digits
  const minuteFormatted = minute < 10 ? "0" + minute : minute;

  // Construct the output format
  return `${month} ${day} ${year} ${hour}:${minuteFormatted} ${ampm}`;
}
export const convertToIST = (dateTimeString = "") => {
  try {
    // Split the datetime string into date and time parts
    const [datePart, timePart] = dateTimeString?.split(" ");

    // Concatenate the date and time parts with 'T' in between
    const isoDateTime = `${datePart}T${timePart}`;

    // Append the timezone offset
    const isoDateTimeWithOffset = isoDateTime + "+05:30";

    return isoDateTimeWithOffset;
  } catch (error) {
    console.error(error);
    return dateTimeString;
  }
};